module.exports = __webpack_public_path__ + "media/react/assets/OnboardingProcess-22d2314655e09c026d0557c58c5e2399.svg";